export class FileFormURL {

    url;

    name;

    id;

    thumbnail_path;

    constructor(url, name, id, thumbnail_path = null) {
        this.url = url;
        this.name = name;
        this.id = id;
        this.thumbnail_path = thumbnail_path;
    }
}
